import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "../../utils/api";

const authHeader = () => {
  const token = localStorage.getItem("access");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchInterviews = createAsyncThunk("interview/fetchAll", async (_, thunkAPI) => {
  try {
    const res = await apiRequest(`/interviews/`, { headers: authHeader() });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (e) {
    return thunkAPI.rejectWithValue(e.message || "Failed to fetch interviews");
  }
});

// interviews slice (e.g., src/redux/slices/interview.js)
export const assignInterview = createAsyncThunk(
  "interview/assign",
  // add status param with a default
  async ({ crew, company, scheduled_at, notes, status = "upcoming" }, thunkAPI) => {
    try {
      const res = await apiRequest(`/interviews/`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify({
          crew: crew ?? null,
          company: company ?? null,
          scheduled_at,
          notes: notes ?? "",
          status, // <-- ensure backend receives "upcoming"
        }),
      });
      if (!res.ok) {
        let msg = `HTTP ${res.status}`;
        try {
          const j = await res.json();
          msg = j?.detail || j?.error || msg;
        } catch {}
        throw new Error(msg);
      }
      return await res.json();
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message || "Failed to assign interview");
    }
  }
);


const interviewSlice = createSlice({
  name: "interview",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchInterviews.pending, (s) => { s.loading = true; s.error = null; })
     .addCase(fetchInterviews.fulfilled, (s, a) => { s.loading = false; s.list = a.payload; })
     .addCase(fetchInterviews.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
     .addCase(assignInterview.fulfilled, (s, a) => { s.list.push(a.payload); });
  },
});

export default interviewSlice.reducer;
